var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrainPumpOnCondenserOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Untitled-1-01",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 111,
    viewBox: "0 0 75 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9825",
    "data-name": "Group 9825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9811",
    "data-name": "Group 9811"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4307",
    "data-name": "Rectangle 4307",
    width: 39.17,
    height: 5.2,
    transform: "translate(0 46.02)",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9824",
    "data-name": "Group 9824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9812",
    "data-name": "Group 9812"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4308",
    "data-name": "Rectangle 4308",
    width: 20.85,
    height: 36.74,
    transform: "translate(48.61 27.92)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M69.6,64.8H48.48V27.79H69.6Zm-20.85-.27H69.34V28.06H48.75Z",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9813",
    "data-name": "Group 9813"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_346",
    "data-name": "Ellipse 346",
    cx: 27.61,
    cy: 27.79,
    rx: 27.61,
    ry: 27.79,
    transform: "translate(14.25 0.13)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M41.86,55.84A27.921,27.921,0,1,1,69.6,27.92,27.871,27.871,0,0,1,41.86,55.84Zm0-55.57A27.651,27.651,0,1,0,69.34,27.92,27.6,27.6,0,0,0,41.86.27Z",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9814",
    "data-name": "Group 9814"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4309",
    "data-name": "Rectangle 4309",
    width: 31.65,
    height: 7.47,
    transform: "translate(43.22 64.67)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M75,72.27H43.08V64.54H75ZM43.35,72H74.74V64.8H43.35Z",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9815",
    "data-name": "Group 9815"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M38.17,17.34a10.47,10.47,0,0,1,5.77-.5,13.035,13.035,0,0,0-2.47-4.35,16.193,16.193,0,0,0-7.01,1.91A13.024,13.024,0,0,1,38.17,17.34Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9816",
    "data-name": "Group 9816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M31.97,22.92a10.647,10.647,0,0,1,3.73-4.46,12.812,12.812,0,0,0-4.81-1.32,16.444,16.444,0,0,0-3.61,6.33A13.239,13.239,0,0,1,31.97,22.92Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9817",
    "data-name": "Group 9817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M31.49,31.5A10.691,10.691,0,0,1,31,25.69a12.93,12.93,0,0,0-4.33,2.49,16.439,16.439,0,0,0,1.9,7.05A13.4,13.4,0,0,1,31.49,31.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9818",
    "data-name": "Group 9818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    d: "M52.22,24.24a10.691,10.691,0,0,1,.49,5.81,12.93,12.93,0,0,0,4.33-2.49,16.439,16.439,0,0,0-1.9-7.05A13.4,13.4,0,0,1,52.22,24.24Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9819",
    "data-name": "Group 9819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M46.53,17.83a10.584,10.584,0,0,1,4.43,3.75,13.035,13.035,0,0,0,1.31-4.84,16.3,16.3,0,0,0-6.29-3.64A13.994,13.994,0,0,1,46.53,17.83Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9820",
    "data-name": "Group 9820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M37.13,38.04a10.584,10.584,0,0,1-4.43-3.75,13.035,13.035,0,0,0-1.31,4.84,16.3,16.3,0,0,0,6.29,3.64A13.73,13.73,0,0,1,37.13,38.04Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9821",
    "data-name": "Group 9821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M45.43,38.51a10.47,10.47,0,0,1-5.77.5,13.035,13.035,0,0,0,2.47,4.35,16.193,16.193,0,0,0,7.01-1.91A13.423,13.423,0,0,1,45.43,38.51Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9822",
    "data-name": "Group 9822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M51.8,32.78a10.647,10.647,0,0,1-3.73,4.46,12.812,12.812,0,0,0,4.81,1.32,16.444,16.444,0,0,0,3.61-6.33A13.7,13.7,0,0,1,51.8,32.78Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9823",
    "data-name": "Group 9823"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_347",
    "data-name": "Ellipse 347",
    cx: 6.31,
    cy: 6.35,
    rx: 6.31,
    ry: 6.35,
    transform: "translate(35.55 21.57)",
    fill: "#fff"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9832",
    "data-name": "Group 9832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9827",
    "data-name": "Group 9827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9826",
    "data-name": "Group 9826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    d: "M66.42,84.71h0l-.04-.09-.15-.27L60.27,73.54,54.32,84.33c-.06.1-.11.2-.16.3l-.04.08h.01a6.933,6.933,0,0,0,6.16,10.03,6.912,6.912,0,0,0,6.89-6.93A7.2,7.2,0,0,0,66.42,84.71Z",
    fill: "#00b7ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9829",
    "data-name": "Group 9829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9828",
    "data-name": "Group 9828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    d: "M57.38,100.31h0l-.02-.05c-.03-.05-.05-.1-.08-.15l-3.3-5.99-3.3,5.98c-.03.05-.06.11-.09.16l-.02.04h0a3.824,3.824,0,1,0,7.23,1.72A3.96,3.96,0,0,0,57.38,100.31Z",
    fill: "#00b7ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9831",
    "data-name": "Group 9831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9830",
    "data-name": "Group 9830"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M68.18,104.36h0l-.03-.06c-.03-.06-.07-.12-.1-.18L64.1,96.96l-3.94,7.15c-.04.06-.07.13-.11.2l-.03.05h0a4.55,4.55,0,1,0,8.16,0Z",
    fill: "#00b7ff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrainPumpOnCondenserOn);
export default __webpack_public_path__ + "static/media/drain_pump_on_condenser_on.c80c66facafe52f3012b7ed1eaa32e1f.svg";
export { ForwardRef as ReactComponent };